import axios from 'axios';
const BASE_URL = process.env.REACT_APP_API;

export const stripeApi = {
  createCheckoutSession: async (formData, planType) => {
    console.log('formData (stripe.api):', formData);
    console.log('---- createCheckoutSession (stripe.api):', planType);
    console.log('BASE_URL, authtoken:', BASE_URL); // Debug URL
    try {
    //   if (!authtoken) {
    //     throw new Error('No auth token provided');
    //   }

      const response = await axios.post(
        `${BASE_URL}/stripe/create-checkout-session`,
        {
          seats: formData.seats,
          name: formData.name,
          email: formData.email,
          companyName: formData.companyName,
          region: formData.region,
          planType,
          paymentSchedule: formData.paymentSchedule
        }
      );
      console.log('createCheckoutSession response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to create checkout session. Details:', {
        error: error.message,
        response: error.response?.data,
        status: error.response?.status,
        baseUrl: BASE_URL,
      });
      throw error; // Throw the original error for better debugging
    }
  },

  validateSession: async (authtoken, sessionId) => {
    console.log('---- validateSession (stripe.api):', sessionId);
    try {
      const response = await axios.get(
        `${BASE_URL}/stripe/validate-session/${sessionId}`,
        {
          headers: {
            authtoken
          }
        }
      );
      console.log('validateSession response:', response.data);
      return response.data;
    } catch (error) {
      throw new Error('Failed to validate session');
    }
  },

  handleSubscriptionSuccess: async (sessionId) => {
    console.log('---- handleSubscriptionSuccess:', sessionId);
    try {
      const response = await axios.post(
        `${BASE_URL}/stripe/subscription/success`,
        { sessionId }
      );
      console.log('handleSubscriptionSuccess response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to handle subscription success. Details:', {
        error: error.message,
        response: error.response?.data,
        status: error.response?.status,
        baseUrl: BASE_URL,
      });
      throw error;
    }
  },

  createUpgradeSession: async (data) => {
    console.log('API received data:', data); // Log incoming data
    console.log('Email value:', data.email); // Specifically log email
    
    try {
      const response = await axios.post(
        `${BASE_URL}/stripe/create-upgrade-session`, 
        {
          ...data,
          email: data.email
        }
      );
      console.log('Data sent to backend:', response.config.data); // Log what's actually being sent
      return response.data;
    } catch (error) {
      console.error('API call failed:', error);
      throw error;
    }
  },

  createRenewSession: async (formData, planType) => {
    console.log('Creating renew session with:', { ...formData, planType });
    try {
      const response = await axios.post(
        `${BASE_URL}/stripe/create-renew-session`,
        {
          ...formData,
          planType,
          email: formData.email // Ensuring email is explicitly included
        }
      );
      console.log('createRenewSession response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to create renew session. Details:', {
        error: error.message,
        response: error.response?.data,
        status: error.response?.status,
        baseUrl: BASE_URL,
      });
      throw error;
    }
  }
};